import { screens } from '@/styles/screens';
import { useEffect, useRef, useState } from 'react';

const { s, m, ml, l } = screens;

export default function useWindowSize() {
  const [isDesktop, setIsDesktop] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isML, setIsML] = useState(false);
  const [isLessThanML, setIsLessThanML] = useState(false);
  const [isM, setIsM] = useState(false);
  const [isS, setIsS] = useState(false);
  const [isXS, setIsXS] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isPortrait, setIsPortrait] = useState(false);
  const [hasScreenSizeChanged, setHasScreenSizeChanged] = useState(false);

  // Use refs to track current values without triggering re-renders
  const currentValues = useRef({
    isDesktop: false,
    isTablet: false,
    isML: false,
    isLessThanML: false,
    isM: false,
    isS: false,
    isXS: false,
    isMobile: false,
  });

  useEffect(() => {
    const handleOrientationChange = () => {
      // Check if orientation is supported
      const orientation = window.screen.orientation?.type;
      if (orientation) {
        setIsPortrait(orientation.includes('portrait'));
      }
    };

    const handleResize = () => {
      const newIsDesktop = window.innerWidth >= l;
      const newIsMobile = window.innerWidth < m;
      const newIsTablet = window.innerWidth >= m && window.innerWidth < l;
      const newIsML = window.innerWidth >= ml && window.innerWidth <= l;
      const newIsM = window.innerWidth >= m && window.innerWidth <= ml;
      const newIsS = window.innerWidth <= m && window.innerWidth >= s;
      const newIsXS = window.innerWidth < s;
      const newIsLessThanML = window.innerWidth < ml;

      // Check if any values have changed using refs
      const hasChanged =
        newIsDesktop !== currentValues.current.isDesktop ||
        newIsMobile !== currentValues.current.isMobile ||
        newIsTablet !== currentValues.current.isTablet ||
        newIsML !== currentValues.current.isML ||
        newIsM !== currentValues.current.isM ||
        newIsS !== currentValues.current.isS ||
        newIsXS !== currentValues.current.isXS ||
        newIsLessThanML !== currentValues.current.isLessThanML;

      // Only update state if values have changed
      if (hasChanged) {
        setHasScreenSizeChanged(true);

        // Update refs first
        currentValues.current = {
          isDesktop: newIsDesktop,
          isMobile: newIsMobile,
          isTablet: newIsTablet,
          isML: newIsML,
          isM: newIsM,
          isS: newIsS,
          isXS: newIsXS,
          isLessThanML: newIsLessThanML,
        };

        // Then update state
        setIsML(newIsML);
        setIsLessThanML(newIsLessThanML);
        setIsM(newIsM);
        setIsS(newIsS);
        setIsXS(newIsXS);
        setIsDesktop(newIsDesktop);
        setIsMobile(newIsMobile);
        setIsTablet(newIsTablet);
      } else {
        setHasScreenSizeChanged(false);
      }
    };

    // Initial call to set values
    handleResize();
    handleOrientationChange();

    // Add event listeners
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleOrientationChange);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, []);

  return {
    isDesktop,
    isMobile,
    isTablet,
    isML,
    isLessThanML,
    isM,
    isS,
    isXS,
    isPortrait,
    hasScreenSizeChanged,
  };
}
